module.exports = __webpack_public_path__ + "img/IMG_9500.444465cb.jpg";